/**
 * Form Submitter Module
 */

import type { ContactFormData, AjaxResponse } from '../types/contact-form';

export class FormSubmitter {
    /**
     * Submit form via AJAX
     */
    async submit(formData: ContactFormData): Promise<AjaxResponse> {
        if (!window.rediGroupAjax) {
            throw new Error('AJAX configuration not found');
        }

        const data = new FormData();
        
        // Add all form data
        Object.entries(formData).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                data.append(key, value.toString());
            }
        });

        try {
            const response = await fetch(window.rediGroupAjax.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result as AjaxResponse;
        } catch (error) {
            console.error('Form submission error:', error);
            return {
                success: false,
                data: window.rediGroupAjax.translations.error || 'An error occurred'
            };
        }
    }

    /**
     * Track conversion (placeholder for analytics)
     */
    trackConversion(): void {
        // Trigger custom event for analytics
        const event = new CustomEvent('contactFormSubmitted', {
            detail: { timestamp: new Date() }
        });
        window.dispatchEvent(event);

        // If Google Analytics is available
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'generate_lead', {
                event_category: 'Contact',
                event_label: 'Contact Form Submission'
            });
        }
    }
}